<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <h3><i class="fa fa-fw fa-building-o"></i> {{ _('Shop') }} {{ shop.shopid }} ({{ shop.id }})</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('General') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 leftcol">
                <div class="form-group">
                  <label for="companyName">{{ _('Company') }}</label>
                  <div class="input-group">
                    <input id="companyName" class="form-control" name="companyname" type="text" v-model="shop.companyname" :disabled="true" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="shopId">{{ _('Shop ID') }}</label>
                  <div class="input-group">
                    <input id="shopId" class="form-control" name="shopid" type="text" v-model="shop.shopid" :disabled="true" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="created">{{ _('Created') }}</label>
                  <div class="input-group">
                    <input id="created" class="form-control" name="created" type="text" :value="DateTime.fromSeconds(Number(shop.creationdate), { zone: timezone }).toFormat(dateFormat)" :disabled="true" />
                  </div>
                </div>
                <h3>{{ _('License') }}</h3>
                <div class="form-group">
                  <label for="status">{{ _('Status') }}</label>
                  <div class="input-group">
                    <span class="form-control" v-html="getStatus(shop)"></span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="notify_ts">{{ _('Notification date') }}</label>
                  <div class="input-group" v-if="shop.license && shop.license.notify_ts">
                    <input id="notify_ts" class="form-control" name="notify_ts" type="text" :value="DateTime.fromSeconds(Number(shop.license.notify_ts), { zone: timezone }).toFormat(dateFormat)" :disabled="true" />
                  </div>
                  <div class="input-group" v-else>
                    <span class="form-control">{{ _('No') }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="grace_ts">{{ _('Grace period end date') }}</label>
                  <div class="input-group" v-if="shop.license && shop.license.grace_ts">
                    <input id="grace_ts" class="form-control" name="grace_ts" type="text" :value="DateTime.fromSeconds(Number(shop.license.grace_ts), { zone: timezone }).toFormat(dateFormat)" :disabled="true" />
                  </div>
                  <div class="input-group" v-else>
                    <span class="form-control">{{ _('No') }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <button class="btn btn-default btn-xs" v-on:click="extendGracePeriodDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Extend grace period') }}</button>
                  <button v-if="shop.license && shop.license.grace_ts" class="btn btn-danger btn-xs" v-on:click="resetGracePeriod"><i class="fa fa-fw fa-trash"></i> {{ _('Reset grace period') }}</button>
                </div>
                <div class="form-group" v-if="shop.license">
                  <label for="messaging_tier">{{ _('Messaging tier') }}</label>
                  <select id="messaging_tier" class="form-control" name="messaging_tier" v-model.number="shop.license.messaging_tier">
                    <option :value="0">{{ _('Restricted') }} — {{ _('new merchant, custom outbound blocked') }}</option>
                    <option :value="1">{{ _('Standard') }}</option>
                    <option :value="2">{{ _('High volume') }}</option>
                    <option :value="3">{{ _('Unrestricted') }} — {{ _('no limits, manual assignment only') }}</option>
                    <option :value="4">{{ _('Blocked') }} — {{ _('all outbound messaging disabled') }}</option>
                  </select>
                  <p class="help-block">{{ _('Controls outbound email and SMS rate limits. Tiers 3 and 4 are never assigned automatically.') }}</p>
                </div>
                <div class="form-group" v-if="shop.license && shop.license.deactivate_ts">
                  <label for="deactivate_ts">{{ _('Deactivation date') }}</label>
                  <div class="input-group">
                    <input id="deactivate_ts" class="form-control" name="deactivate_ts" type="text" :value="DateTime.fromSeconds(Number(shop.license.deactivate_ts), { zone: timezone }).toFormat(dateFormat)" :disabled="true" />
                  </div>
                </div>
                <div class="form-group" v-if="shop.license && !parseInt(shop.destroycode?.confirmed)">
                  <button class="btn btn-danger btn-xs" v-on:click="destroyShopDialog"><i class="fa fa-fw fa-trash"></i> {{ _('Destroy shop') }}</button>
                </div>
              </div>
              <div class="col-sm-6 rightcol">
                <div class="form-group">
                  <label for="featureFilter">{{ _('Features') }}</label>
                  <input id="featureFilter" class="form-control input-sm" type="text" v-model="featureFilter" :placeholder="_('Filter features')" />
                </div>
                <div class="feature-group" v-for="group in featureGroups" :key="group.id">
                  <h4>{{ group.title }}</h4>
                  <div v-for="feature in group.features" :key="feature.id" :class="['checkbox', 'feature-row', featureChangeClass(feature.id)]">
                    <label>
                      <input type="checkbox" :value="feature.id" v-model="selectedFeatures" />
                      <strong v-if="feature.label">{{ feature.label }}</strong> <code>{{ feature.id }}</code>
                      <span v-if="feature.default" class="label label-default">{{ _('Default') }}</span>
                      <span v-if="feature.unlisted" class="label label-warning">{{ _('Not in catalog') }}</span>
                    </label>
                    <p class="help-block" v-if="feature.description || feature.managed">
                      {{ feature.description }}
                      <em v-if="feature.managed === 'billing'">{{ _('Synced from the Johku Max subscription.') }}</em>
                      <em v-if="feature.managed === 'merchant'">{{ _('Merchant can toggle this in their own settings.') }}</em>
                    </p>
                  </div>
                </div>
                <button class="btn btn-primary btn-xs" v-on:click="addFeatureDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Add custom feature') }}</button>
              </div>
            </div>            
          </div>
          <div v-bind="tabPanel('actions')" class="tab-pane active" id="actions" v-if="isTabActive('actions')" key="actions">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Actions') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>{{ _('Products') }}</label><br />
                  <button class="btn btn-primary btn-xs" v-on:click="indexProducts"><i class="fa fa-fw fa-repeat"></i> {{ _('Recreate product search index') }}</button>
                  <button class="btn btn-primary btn-xs" v-on:click="showDeletedProducts"><i class="fa fa-fw fa-trash"></i> {{ _('Deleted products') }}</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>{{ _('Resources') }}</label><br />
                  <button class="btn btn-primary btn-xs" v-on:click="showDeletedResources"><i class="fa fa-fw fa-trash"></i> {{ _('Deleted resources') }}</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>{{ _('Channex') }}</label><br />
                  <button class="btn btn-primary btn-xs" v-on:click="inviteToChannex"><i class="fa fa-fw fa-envelope"></i> {{ _('Send invitation to Channex') }}</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>{{ _('MobilePay') }}</label><br />
                  <button class="btn btn-primary btn-xs" v-on:click="resetMobilepay('online')" :disabled="!shop.settings || shop.settings.pay_option18_msn !== 'pending'"><i class="fa fa-fw fa-repeat"></i> {{ _('Reset Online Application') }}</button>
                  <button class="btn btn-primary btn-xs" v-on:click="resetMobilepay('pos')" :disabled="!shop.settings || shop.settings.pay_option18_msn_pos !== 'pending'"><i class="fa fa-fw fa-repeat"></i> {{ _('Reset POS Application') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('commission')" class="tab-pane active" id="commission" v-if="isTabActive('commission')" key="commission">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Commission') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-6">
                <div class="form-group">
                  <label>{{ _('Type') }}</label><br />
                  <select class="form-control" v-model="commissionType">
                    <option value="default">{{ _('Default') }}</option>
                    <option value="fixed">{{ _('Fixed') }}</option>
                    <option value="none">{{ _('None') }}</option>
                    <option value="custom">{{ _('Custom') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-xs-6" v-if="commissionType === 'fixed'">
                <div class="form-group">
                  <label>{{ _('Fixed percentage') }}</label><br />
                  <input class="form-control" type="number" v-model="fixedPercentage" />
                </div>
              </div>
            </div>
            <div class="row" v-if="commissionType === 'custom'">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>{{ _('Custom commission steps') }} (JSON)</label><br />
                  <textarea class="form-control" v-model="customCommission" rows="10"></textarea>
                </div>
                <button class="btn btn-primary btn-xs" v-on:click="updateCustomCommission"><i class="fa fa-fw fa-robot"></i> {{ _('Parse') }}</button>
                <button class="btn btn-default btn-xs" v-on:click="useDefaultSteps"><i class="fa fa-fw fa-refresh"></i> {{ _('Start from default') }}</button>
              </div>
            </div>
            <div v-if="shop.license && shop.license.provisionsteps" class="commission-steps-table">
              <h4>{{ _('Commission Tiers') }}</h4>
              <table class="table table-striped table-condensed">
                <thead>
                  <tr>
                    <th>{{ _('Minimum Sales') }}</th>
                    <th>{{ _('Commission %') }}</th>
                    <th>{{ _('Sales Range') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(step, index) in parsedProvisionSteps" :key="index">
                    <td>{{ $filters.currency(step.min, undefined, 0) }}</td>
                    <td>{{ step.perc }}%</td>
                    <td>
                      {{ $filters.currency(step.min, undefined, 0) }} - 
                      {{ index < parsedProvisionSteps.length - 1 ? $filters.currency(parsedProvisionSteps[index + 1].min - 1, undefined, 0) : _('and above') }} 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="shop.license">
              <em>{{ _('Using default commission structure') }}</em>
            </div>
          </div>
          <div v-bind="tabPanel('sales')" class="tab-pane active" id="sales" v-if="isTabActive('sales')" key="sales">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Sales') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 leftcol">
                <div class="form-group">
                  <label for="totalSales">{{ _('Total sales') }}</label>
                  <div class="input-group">
                    <input id="totalSales" class="form-control" name="totalSales" type="text" :value="totalSales" :disabled="true" />
                  </div>
                </div>
              </div>
              <div class="col-sm-6 rightcol">
                <div class="form-group">
                  <label for="totalCommission">{{ _('Total commission') }}</label>
                  <div class="input-group">
                    <input id="totalCommission" class="form-control" name="totalCommission" type="text" :value="totalCommission" :disabled="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 leftcol">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ _('Month') }}</th>
                      <th style="text-align: right">{{ _('Sales') }}</th>
                      <th style="text-align: right">{{ _('Commission') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="sale in shop.ownSales">
                      <td>{{ sale.month }}</td>
                      <td style="text-align: right">{{ $filters.currency(sale.sales) }}</td>
                      <td style="text-align: right">{{ $filters.currency(sale.commission) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <div class="flex-row">
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import changewatcher from '~/lib/changewatcher'
import components from '~/lib/components'
import DeletedItemsRestore from '~/components/modals/DeletedItemsRestore'

export default {
  data () {
    return {
      shop: {},
      featureCatalog: { categories: {}, features: [] },
      featureFilter: '',
      origFeatures: [],
      selectedFeatures: [],
      DateTime: DateTime,
      commissionType: 'default',
      _fixedPercentage: null,
      _customCommission: '',
      origSteps: null,
      origMessagingTier: null,
      defaultSteps: '[{"min":0,"perc":2.5},{"min":10000,"perc":2.25},{"min":20000,"perc":1.75},{"min":30000,"perc":1.5},{"min":40000,"perc":1.3},{"min":50000,"perc":1.2},{"min":75000,"perc":1},{"min":150000,"perc":0.85},{"min":300000,"perc":0.725},{"min":400000,"perc":0.65},{"min":500000,"perc":0.575},{"min":600000,"perc":0.5},{"min":700000,"perc":0.45},{"min":800000,"perc":0.4},{"min":900000,"perc":0.375},{"min":1000000,"perc":0.35},{"min":1500000,"perc":0.275},{"min":2000000,"perc":0.225},{"min":3000000,"perc":0.15},{"min":4000000,"perc":0.1},{"min":5000000,"perc":0.1}]',
    }
  },
  mixins: [changewatcher, components],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'actions', label: this._('Actions') },
        { id: 'commission', label: this._('Commission') },
        { id: 'sales', label: this._('Sales') }
      ])
    },
    fixedPercentage: {
      get () {
        if (this._fixedPercentage) {
          return this._fixedPercentage
        }
        if (this.shop.license && this.shop.license.provisionsteps) {
          const parsed = JSON.parse(this.shop.license.provisionsteps)
          if (parsed.length === 1 && parsed[0].perc) {
            return parsed[0].perc
          }
        }
        return 0
      },
      set (value) {
        if (value && parseFloat(value) >= 0) {
          this._fixedPercentage = value
          this.shop.license.provisionsteps = '[{"min":0,"perc":' + parseFloat(value) + '}]'
        }
      }
    },
    customCommission: {
      get () {
        if (this._customCommission) {
          return this._customCommission
        }
        if (this.shop.license && this.shop.license.provisionsteps) {
          return this.shop.license.provisionsteps
        }
        return ''
      }, 
      set (value) {
        this._customCommission = value
      }
    },
    enableFeatures () {
      return this.selectedFeatures.filter(f => !this.origFeatures.includes(f)).sort()
    },
    disableFeatures () {
      return this.origFeatures.filter(f => !this.selectedFeatures.includes(f)).sort()
    },
    featureGroups () {
      const filter = this.featureFilter.trim().toLowerCase()
      const matches = (feature) => !filter ||
        feature.id.toLowerCase().includes(filter) ||
        (feature.label || '').toLowerCase().includes(filter) ||
        (feature.description || '').toLowerCase().includes(filter)
      const catalogIds = this.featureCatalog.features.map(f => f.id)
      const groups = Object.entries(this.featureCatalog.categories || {}).map(([id, title]) => ({
        id,
        title,
        features: this.featureCatalog.features.filter(f => f.category === id && matches(f))
      }))
      const unlisted = [...new Set([...this.origFeatures, ...this.selectedFeatures])]
        .filter(f => !catalogIds.includes(f))
        .sort()
        .map(id => ({ id, label: '', unlisted: true }))
        .filter(matches)
      groups.push({ id: 'unlisted', title: this._('Unlisted'), features: unlisted })
      return groups.filter(g => g.features.length)
    },
    totalSales () {
      const curr = this.$filters.currency
      if (!this.shop || !this.shop.ownSales) {
        return curr(0)
      }
      return curr(this.shop.ownSales.reduce((a, e) => a + parseFloat(e.sales), 0))
    },
    totalCommission () {
      const curr = this.$filters.currency
      if (!this.shop || !this.shop.ownSales) {
        return curr(0)
      }
      return curr(this.shop.ownSales.reduce((a, e) => a + parseFloat(e.commission), 0))
    },
    parsedProvisionSteps () {
      if (this.shop.license && this.shop.license.provisionsteps) {
        try {
          return JSON.parse(this.shop.license.provisionsteps).sort((a, b) => a.min - b.min)
        } catch (e) {
          return []
        }
      }
      return []
    }
  },
  methods: {
    updateCustomCommission () {
      try {
        // Parse the JSON to validate format
        const parsed = JSON.parse(this.customCommission)
        
        // Validate that it's an array
        if (!Array.isArray(parsed)) {
          throw new Error('Commission data must be an array')
        }
        
        // Validate each step has required properties and correct types
        for (let i = 0; i < parsed.length; i++) {
          const step = parsed[i]
          
          if (typeof step !== 'object' || step === null) {
            throw new Error(`Step ${i + 1}: Must be an object`)
          }
          
          if (!step.hasOwnProperty('min') || !step.hasOwnProperty('perc')) {
            throw new Error(`Step ${i + 1}: Must have 'min' and 'perc' properties`)
          }
          
          if (typeof step.min !== 'number' || isNaN(step.min) || step.min < 0) {
            throw new Error(`Step ${i + 1}: 'min' must be a non-negative number`)
          }
          
          if (typeof step.perc !== 'number' || isNaN(step.perc) || step.perc < 0) {
            throw new Error(`Step ${i + 1}: 'perc' must be a non-negative number`)
          }
        }
        
        // Validate that min values are unique and properly ordered
        const minValues = parsed.map(step => step.min).sort((a, b) => a - b)
        const uniqueMinValues = [...new Set(minValues)]
        if (minValues.length !== uniqueMinValues.length) {
          throw new Error('Duplicate minimum values are not allowed')
        }
        
        // If all validation passes, update the provision steps
        this.shop.license.provisionsteps = this.customCommission
        this.showNotification(this._('Commission structure parsed and updated successfully!'))
        
      } catch (error) {
        this.showError(
          this._('Invalid commission format') + ': ' + error.message + '. ' + 
                      this._('Expected format') + ': [{"min":0,"perc":2.5},{"min":10000,"perc":2.25}]'
        )
      }
    },
    useDefaultSteps () {
      this.shop.license.provisionsteps = this._customCommission = this.defaultSteps
    },
    destroyShopDialog () {
      const _ = this._
      this.showDialog({
        title: _('Destroy shop?'),
        buttons: [
          {
            title: _('Cancel'),
            class: 'default',
            icon: 'close',
            handler: () => {}
          },
          {
            title: _('Ok'),
            class: 'success',
            icon: 'check',
            handler: () => {
              this.destroyShop()
            }
          }
        ]
      })
    },
    async destroyShop () {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/admin/shops/' + this.shop.shopid + '.json?apikey=' + this.apiKey, {
          operation: 'forceDestroy',
          shops: [this.shop.shopid]
        })
        await this.loadShop(this.shop.shopid)
      } catch(e) {
        return this.showError(e)
      }
    },
    extendGracePeriodDialog () {
      const _ = this._
      this.showDialog({
        title: _('Extend grace period'),
        fields: [
          {
            title: _('Grace period end date'),
            name: 'grace_ts',
            type: 'date',
            required: true
          }
        ],
        buttons: [
          {
            title: _('Cancel'),
            class: 'default',
            icon: 'close',
            handler: () => {}
          },
          {
            title: _('Ok'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              this.extendGracePeriod(data.grace_ts)
            }
          }
        ]
      })
    },
    async extendGracePeriod (grace_ts) {
      grace_ts = DateTime.fromSeconds(Number(grace_ts), { zone: this.timezone }).toSeconds()
      try {
        await axios.patch(this.baseDomain + this.shopId + '/admin/shops/' + this.shop.shopid + '.json?apikey=' + this.apiKey, {
          operation: 'gracePeriod',
          grace_ts: grace_ts
        })
      } catch(e) {
        return this.showError(e)
      }
      await this.loadShop(this.shop.shopid)
      this.showNotification(this._('Grace period extended successfully!'))
      this.$emit('save', this.shop)
    },
    async resetGracePeriod () {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/admin/shops/' + this.shop.shopid + '.json?apikey=' + this.apiKey, {
          operation: 'gracePeriod',
          grace_ts: 0
        })
      } catch(e) {
        return this.showError(e)
      }
      await this.loadShop(this.shop.shopid)
      this.showNotification(this._('Grace period reset successfully!'))
      this.$emit('save', this.shop)
    },
    getStatus(shop) {
      if (shop.destroycode && parseInt(shop.destroycode.confirmed)) {
        return '<i class="fa fa-fw fa-trash"></i> Destroy pending'
      }
      if (parseInt(shop.locked)) {
        return '<i class="fa fa-fw fa-lock"></i> Locked'
      }
      if (parseInt(shop.notified)) {
        return '<i class="fa fa-fw fa-exclamation-triangle"></i> Notified'
      }
      if (!parseInt(shop.enabled)) {
        return '<i class="fa fa-fw fa-ban"></i> Disabled'
      }
      return '<i class="fa fa-fw fa-check"></i> Enabled'
    },
    getSaveData () {
      const exportFields = [
        'shopid'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.shop[e], a), {})
      data.disableFeatures = [...this.disableFeatures]
      data.enableFeatures = [...this.enableFeatures]
      data.source = 'editor'
      data.shops = [data.shopid]
      return data
    },
    featureChangeClass (feature) {
      if (this.enableFeatures.includes(feature)) {
        return 'feature-added'
      }
      if (this.disableFeatures.includes(feature)) {
        return 'feature-removed'
      }
      return ''
    },
    async loadFeatureCatalog () {
      try {
        const response = await axios.get(this.baseDomain + this.shopId + '/admin/features.json?apikey=' + this.apiKey)
        this.featureCatalog = {
          categories: response.data.categories || {},
          features: response.data.features || []
        }
      } catch (e) {
        this.showError(e)
      }
    },
    addFeatureDialog () {
      const _ = this._
      this.showDialog({
        title: _('Add custom feature'),
        fields: [
          {
            title: _('Feature identifier'),
            name: 'feature',
            type: 'text',
            required: true
          }
        ],
        buttons: [
          { 
            title: _('Ok'), 
            class: 'success', 
            icon: 'check',
            handler: (data) => {
              this.addFeature(data.feature)
            }
          }
        ]
      })
    },
    addFeature (feature) {
      feature = (feature || '').trim()
      if (feature && !this.selectedFeatures.includes(feature)) {
        this.selectedFeatures.push(feature)
      }
    },
    async indexProducts () {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/admin/shops/' + this.shop.shopid + '.json?apikey=' + this.apiKey, {
          operation: 'indexProducts',
          shops: [this.shop.shopid]
        })
      } catch(e) {
        return this.showError(e)
      }
    },
    showDeletedItems (kind) {
      this.showModal('deleteditemsrestore', DeletedItemsRestore, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          targetShopId: this.shop.shopid,
          kind
        },
        handlers: {},
        width: 800,
        scrollable: true
      })
    },
    showDeletedProducts () {
      this.showDeletedItems('product')
    },
    showDeletedResources () {
      this.showDeletedItems('resource')
    },
    async inviteToChannex () {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/admin/shops/' + this.shop.shopid + '.json?apikey=' + this.apiKey, {
          operation: 'inviteToChannex',
          shops: [this.shop.shopid]
        })
      } catch(e) {
        return this.showError(e)
      }
      this.showNotification(this._('Invitation to Channex sent!'))
    },
    async resetMobilepay (type) {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/admin/shops/' + this.shop.shopid + '.json?apikey=' + this.apiKey, {
          operation: 'resetMobilepay',
          type: type,
          shops: [this.shop.shopid]
        })
      } catch(e) {  
        return this.showError(e)
      }
      this.showNotification(this._('MobilePay application reset successfully!'))
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      const operations = []
      if (data.disableFeatures.length || data.enableFeatures.length) {
        operations.push('features')
      }
      if (this.origSteps !== this.shop.license.provisionsteps) {
        operations.push('provisionSteps')
        data.provisionsteps = this.origSteps = this.shop.license.provisionsteps
      }
      if (this.shop.license && this.origMessagingTier !== null && this.origMessagingTier !== this.shop.license.messaging_tier) {
        operations.push('messagingTier')
        data.messaging_tier = this.origMessagingTier = this.shop.license.messaging_tier
      }
      for (const operation of operations) {
        data.operation = operation
        data.shops = [data.shopid]
        try {
          response = await axios.patch(this.baseDomain + this.shopId + '/admin/shops/' + data.shopid + '.json?apikey=' + this.apiKey, data)
        } catch(e) {
          this.saving = false
          return this.showError(e)
        }
      }
      if (operations.includes('features')) {
        this.selectedFeatures.sort()
        this.origFeatures = [...this.selectedFeatures]
        if (this.shop.settings) {
          this.shop.settings.features = this.selectedFeatures.join(';')
        }
        if (data.shopid === this.shopId) {
          await this.$store.dispatch('reloadSettings')
        }
      }
      if (response && response.data && response.data.id) {
        await this.loadShop(data.shopid)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.shop)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadShop (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/admin/shops/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.shop = response.data
        this.origFeatures = this.shop.settings && this.shop.settings.features ? this.shop.settings.features.split(';').filter(Boolean).sort() : []
        this.selectedFeatures = [...this.origFeatures]
        if (this.shop.license) {
          this.origMessagingTier = parseInt(this.shop.license.messaging_tier, 10)
          if (isNaN(this.origMessagingTier)) {
            this.origMessagingTier = 0
          }
          this.shop.license.messaging_tier = this.origMessagingTier
        }
        this.storeState()
        this.loading = false
        resolve(this.shop)
      })
    },
    updateLicenseType () {
      if (this.shop.license && this.shop.license.provisionsteps) {
        this.origSteps = this.shop.license.provisionsteps
        const parsed = JSON.parse(this.shop.license.provisionsteps)
        if (parsed.length > 1) {
          this.commissionType = 'custom'
        }
        if (parsed.length === 1) {
          this.commissionType = 'fixed'
        }
      } else {
        this.commissionType = 'default'
      }
    }
  },
  watch: {
    fixedPercentage: {
      handler (value) {
        if (this.commissionType === 'fixed' && parseFloat(value) >= 0) {
          this.shop.license.provisionsteps = '[{"min":0,"perc":' + parseFloat(value) + '}]'
        }
      }
    },
    commissionType: {
      handler (value) {
        if (value === 'default') {
          this.shop.license.provisionsteps = null
        }
        if (value === 'none') {
          this.shop.license.provisionsteps = '[{"min":0,"perc":0}]'
        }
        if (value === 'fixed') {
          this.shop.license.provisionsteps = '[{"min":0,"perc":' + parseFloat(this.fixedPercentage) + '}]'
        }
      }
    }
  },
  async created () {
    this.loadFeatureCatalog()
    if (this.component && this.component.initData) {
      await this.loadShop(this.component.initData.shopId)
      this.updateLicenseType()
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.shop && this.shop.shopid && this.shop.shopid !== this.component.initData.shopId) {
        try {
          await this.loadShop(this.component.initData.shopId)
          this.updateLicenseType()
        } catch(e) {}
      }
    }
  }
}
</script>


<style scoped>
.feature-group h4 {
  margin-top: 15px;
}
.feature-row {
  margin: 0;
  padding: 2px 6px;
  border-radius: 3px;
}
.feature-row .help-block {
  margin: 0 0 4px 20px;
}
.feature-added {
  background-color: #dff0d8;
}
.feature-removed {
  background-color: #f2dede;
}
</style>
